<template>
	<v-alert v-model="alert" prominent text>
		<v-row align="center">
			<v-col class="grow">
				<span class="success--text">{{ item.name }}</span> invitado unirte a la empresa
				{{ item.company }}.
			</v-col>
			<v-col class="shrink">
				<v-btn
					:disabled="disabled"
					fab
					x-small
					color="success"
					@click="accept(item.idCompany, item.editable)"
				>
					<v-icon>mdi-check-bold</v-icon>
				</v-btn>
			</v-col>
			<v-col class="shrink">
				<v-btn
					v-if="alert"
					:disabled="disabled"
					fab
					x-small
					color="error"
					@click="remove(item.idCompany)"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-alert>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	props: {
		index: {
			type: Number,
		},
		item: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			alert: true,
			disabled: false,
		};
	},
	computed: {
		...mapGetters({
			person: 'Person/person',
		}),
	},
	methods: {
		async accept(idCompany, editable) {
			this.disabled = true;
			if (this.person.idCompany) {
				this.disabled = false;
				return this.snackbar({
					content: 'Ya perteneces a un equipo',
					color: 'info',
				});
			}
			this.person.request.splice(this.index, 1);
			await this.handlerRequest({
				_id: this.person._id,
				request: this.person.request,
				idCompany,
				editable,
			});
			if (this.person && this.person.idCompany)
				await this.fetchProfileById(this.person.idCompany);
			this.disabled = false;
			this.alert = false;
		},
		async remove() {
			this.disabled = true;
			this.person.request.splice(this.index, 1);
			await this.handlerRequest({
				_id: this.person._id,
				request: this.person.request,
			});
			if (this.person && this.person.idCompany)
				await this.fetchProfileById(this.person.idCompany);
			this.disabled = false;
			this.alert = false;
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
		...mapActions({
			handlerRequest: 'Person/handlerRequest',
			fetchProfileById: 'User/fetchProfileById',
		}),
	},
};
</script>
